"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponentDemoId = exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _antd = require("antd");
var _icons = require("../icons");
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ComponentTokenDrawer = _interopRequireDefault(require("./ComponentTokenDrawer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyle = (0, _makeStyle.default)('ComponentCard', function (token) {
  return (0, _defineProperty2.default)({}, "".concat(token.rootCls, "-card.component-card"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    borderRadius: 6,
    boxShadow: "0 1px 2px 0 rgba(25,15,15,0.07)"
  }, "".concat(token.rootCls, "-card-head"), (0, _defineProperty2.default)({
    paddingInline: 18
  }, "".concat(token.rootCls, "-card-head-title"), {
    paddingBlock: token.paddingSM,
    fontSize: token.fontSize
  })), "".concat(token.rootCls, "-card-body"), {
    padding: 18,
    overflow: 'auto'
  }), '.component-token-control-icon', {
    color: token.colorIcon,
    transition: "color ".concat(token.motionDurationMid),
    fontSize: token.fontSizeLG,
    cursor: 'pointer',
    '&:hover': {
      color: token.colorIconHover
    }
  }));
});
var getComponentDemoId = exports.getComponentDemoId = function getComponentDemoId(component) {
  return "antd-token-previewer-".concat(component);
};
var ComponentCard = function ComponentCard(_ref2) {
  var children = _ref2.children,
    component = _ref2.component,
    title = _ref2.title,
    theme = _ref2.theme,
    drawer = _ref2.drawer;
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    wrapSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    drawerOpen = _useState2[0],
    setDrawerOpen = _useState2[1];
  return wrapSSR( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    className: (0, _classnames.default)('component-card', hashId),
    title: title,
    extra: drawer && theme && /*#__PURE__*/_react.default.createElement(_icons.Control, {
      className: "component-token-control-icon",
      onClick: function onClick() {
        return setDrawerOpen(true);
      }
    })
  }, children), drawer && theme && /*#__PURE__*/_react.default.createElement(_ComponentTokenDrawer.default, {
    visible: drawerOpen,
    theme: theme,
    component: component,
    onClose: function onClose() {
      return setDrawerOpen(false);
    }
  })));
};
var _default = exports.default = ComponentCard;